import React from 'react'
import classnames from 'classnames'
import { addCTAs } from './Links'
import GoToTokenPageCTA from './GoToTokenPageCTA'

function evalConfig(config) {
  return classnames({
    'aside-left': config.justification === 'LEFT',
    'aside-center': config.justification === 'CENTER',
    'aside-right': config.justification === 'RIGHT',
    'aside-wide': config.width === 'WIDE',
    'aside-narrow': config.width === 'NARROW'
  })
}

function HeroAside({ content }) {
  return (
    <aside className={'aside-hero'}>
      <div className={'aside-content'}>
        <h1>{content.h}</h1>
        <p>{content.p}</p>
        {content.cta ? addCTAs(content.cta) : null}
      </div>
    </aside>
  )
}

function HeroAsideWithNewsletter({ content }) {
  return (
    <aside className={'aside-hero'}>
      <div className={'aside-content'}>
        <h1>{content.h}</h1>
        <p>{content.p}</p>
        <GoToTokenPageCTA />
      </div>
    </aside>
  )
}

function MainAside({ content }) {
  return (
    <aside className={`${evalConfig(content)} aside-main`}>
      <div className={'aside-content'}>
        {content.hasOwnProperty('icn') ? (
          <img className={'icn'} src={content.icn.src} alt={content.icn.alt} />
        ) : null}
        <h1>{content.h}</h1>
        <p>{content.p}</p>
        {content.cta ? addCTAs(content.cta) : null}
      </div>
    </aside>
  )
}

function SubAside({ content }) {
  return (
    <aside className={`${evalConfig(content)} aside-sub`}>
      <div className={'aside-content'}>
        <h2>{content.h}</h2>
        <p>{content.p}</p>
        {content.cta ? addCTAs(content.cta) : null}
      </div>
    </aside>
  )
}

export { HeroAside, MainAside, SubAside, HeroAsideWithNewsletter }



// WEBPACK FOOTER //
// ./src/Components/Aside.js